import Grid from '@material-ui/core/Grid'
import EditIcon from '@material-ui/icons/Edit'
import React from 'react'
import { Button, Datagrid, EditButton, Filter, List, ReferenceField, ReferenceInput, Responsive, SimpleList, TextField, SelectInput } from 'react-admin'
import { Link } from 'react-router-dom'

import { ListActions, TableRowList } from '../../../components'
import { DateField, MatchStatusField } from '../../../components/field'
import { AutocompleteInput, DateRangeInput, MatchInput } from '../../../components/inputs'
import { getResource } from '../../../config/resources'

const MatchesFilter = (props) => {
  return (
    <Filter {...props}>
      <Grid container alwaysOn>
        <Grid item xs={12} sm={4}>
          <DateRangeInput source="date" label="Date" fullWidth alwaysOn />
        </Grid>
        <Grid item xs={12} md={2}>
          <ReferenceInput source="status" label="Status" reference={getResource('competiciones', 'matchStatus')} alwaysOn allowEmpty fullWidth>
            <SelectInput />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={3}>
          <ReferenceInput
            source="hometeam"
            label="Home Team"
            reference={getResource('competiciones', 'teams')}
            sort={{ field: 'id', order: 'ASC' }}
            alwaysOn
            allowEmpty
          >
            <AutocompleteInput optionText="selectorName" />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} sm={3}>
          <ReferenceInput
            source="awayteam"
            label="Away Team"
            reference={getResource('competiciones', 'teams')}
            sort={{ field: 'id', order: 'ASC' }}
            alwaysOn
            allowEmpty
          >
            <AutocompleteInput optionText="selectorName" />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12}>
          <MatchInput
            sourceSeason="season"
            sourceCompetition="competitionId"
            sourceSubscription="subscription"
            sourceRound="round"
            sourceGameweek="gameweek"
            sourceMatch={false}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const Actions = (props) => {
  return <ListActions {...props} filters={<MatchesFilter />} />
}

const MatchesList = (props) => (
  <List bulkActions={false} title="Clubs" actions={<Actions />} {...props}>
    <Responsive
      small={
        <SimpleList
          primaryText={(record) => record.name}
          tertiaryText={(record) => (
            <div>
              <DateField source="date" label="Date" record={record} />
              <DateField
                source="time"
                label="Time"
                showTime
                record={record}
                options={{
                  hour: 'numeric',
                  minute: 'numeric',
                }}
              />
            </div>
          )}
        />
      }
      medium={
        <Datagrid>
          <MatchStatusField label={false} source="status" />
          <ReferenceField label="Season" source="gameweek.round.id" reference={getResource('competiciones', 'rounds')} linkType={false} sortable={false}>
            <TextField source="subscription.season.name" />
          </ReferenceField>
          <ReferenceField label="Competition" source="gameweek.round.id" reference={getResource('competiciones', 'rounds')} linkType={false} sortable={false}>
            <TextField source="subscription.competition.name" />
          </ReferenceField>
          <ReferenceField label="Subscription" source="gameweek.round.id" reference={getResource('competiciones', 'rounds')} linkType={false} sortable={false}>
            <TextField source="subscription.competitionName" />
          </ReferenceField>
          <ReferenceField label="Round" source="gameweek.round.id" reference={getResource('competiciones', 'rounds')} linkType={false} sortable={false}>
            <TextField source="name" />
          </ReferenceField>
          <TextField source="gameweek.name" label="Game Week" sortable={false} />
          <TextField source="homeTeam.nickname" label="Home Team" sortable={false} />
          <TextField source="awayTeam.nickname" label="Away Team" sortable={false} />
          <DateField source="date" label="Date" />
          <DateField
            source="time"
            label="Time"
            showTime
            options={{
              hour: 'numeric',
              minute: 'numeric',
            }}
          />
          <TableRowList>
            <EditButton />
          </TableRowList>
        </Datagrid>
      }
    />
  </List>
)

export default MatchesList
